import React, { Component } from "react";
import {
    Row, Col, Card, Button, Form, Spinner, FormGroup, Label, CardTitle, CardText, CardBody, Table, Input
} from 'reactstrap';
import dateFormat, { masks } from "dateformat";
import { AppContext } from './../AppContext';
import url from './variables/url.js';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const local = url.localBack;
const MySwal = withReactContent(Swal)

class Configuracion extends Component {
    constructor(props) {
        super(props);
        let currentUser = this.context;
        this.state = {
            loading: true, updateP: false, updateS: false, updateD: false, updateV: false,
            iduser: 0,
            roles: [],
            idperiodo: 0,
            nombrePeriodo: "",
            docentes: {},
            subdecanos: {},
            decanos: {},
            vicerrector: {},
            data: {},
        };
    }

    componentDidMount() {
        let currentUser = this.context
        if (currentUser != null) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            if (currentUser.roles.includes('ADMINISTRADOR')) {
                this.populate();
            } else {
                this.isForbidden();
            }

        }

    }

    isForbidden() {
        this.props.history.push({
            pathname: '/',
        })
    }

    componentDidUpdate() {
        let currentUser = this.context
        if (currentUser != null && this.state.iduser == 0) {
            /*console.log("updateded");*/
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            /*console.log(currentUser.roles);*/
            if (currentUser.roles.includes('ADMINISTRADOR')) {
                this.populate();
            } else {
                this.isForbidden();
            }
        }
    }

    handleSaveP() {
        let docente = this.state.docentes;
        this.setState({ updateP: true });
        let problemas = 0;
        if (problemas === 0) {                    
            const data = JSON.stringify(docente);
            fetch(local + 'Administrador/PostAccesoConfig', {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: data,
            }).then((response) => {
                if (response.ok) {                    
                    this.setState({ updateP: false });
                    MySwal.fire({
                        icon: 'success',
                        title: 'Actulizado',
                        text: 'Se han actualizado las fechas para Docentes!',
                        confirmButtonText: 'Listo',
                        timer: 5000
                    })
                } else {
                    this.setState({ updateP: false });
                    MySwal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'A ocurrido un problema!',
                        confirmButtonText: 'Listo',
                        timer: 5000
                    })
                }
            })
        } else {
            this.setState({ updateP: false });
            MySwal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'A ocurrido un problema!',
                confirmButtonText: 'Listo',
                timer: 5000
            })
        }
    }

    handleSaveS() {
        let docente = this.state.subdecanos;
        this.setState({ updateS: true });
        let problemas = 0;
        if (problemas === 0) {
            const data = JSON.stringify(docente);
            fetch(local + 'Administrador/PostAccesoConfig', {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: data,
            }).then((response) => {
                if (response.ok) {
                    this.setState({ updateS: false });
                    MySwal.fire({
                        icon: 'success',
                        title: 'Actulizado',
                        text: 'Se han actualizado las fechas para Subdecanos y Coordinadores!',
                        confirmButtonText: 'Listo',
                        timer: 5000
                    })
                } else {
                    this.setState({ updateS: false });
                    MySwal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'A ocurrido un problema!',
                        confirmButtonText: 'Listo',
                        timer: 5000
                    })
                }
            })
        } else {
            this.setState({ updateS: false });
            MySwal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'A ocurrido un problema!',
                confirmButtonText: 'Listo',
                timer: 5000
            })
        }
    }

    handleSaveD() {
        let docente = this.state.decanos;
        this.setState({ updateD: true });
        let problemas = 0;
        if (problemas === 0) {
            const data = JSON.stringify(docente);
            fetch(local + 'Administrador/PostAccesoConfig', {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: data,
            }).then((response) => {
                if (response.ok) {
                    this.setState({ updateD: false });
                    MySwal.fire({
                        icon: 'success',
                        title: 'Actulizado',
                        text: 'Se han actualizado las fechas para Decano!',
                        confirmButtonText: 'Listo',
                        timer: 5000
                    })
                } else {
                    this.setState({ updateD: false });
                    MySwal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'A ocurrido un problema!',
                        confirmButtonText: 'Listo',
                        timer: 5000
                    })
                }
            })
        } else {
            this.setState({ updateD: false });
            MySwal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'A ocurrido un problema!',
                confirmButtonText: 'Listo',
                timer: 5000
            })
        };
    }

    handleSaveV() {
        let docente = this.state.vicerrector;
        this.setState({ updateV: true });
        let problemas = 0;
        if (problemas === 0) {
            const data = JSON.stringify(docente);
            fetch(local + 'Administrador/PostAccesoConfig', {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: data,
            }).then((response) => {
                if (response.ok) {
                    this.setState({ updateV: false });
                    MySwal.fire({
                        icon: 'success',
                        title: 'Actulizado',
                        text: 'Se han actualizado las fechas para Vicerrector!',
                        confirmButtonText: 'Listo',
                        timer: 5000
                    })
                } else {
                    this.setState({ updateV: false });
                    MySwal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'A ocurrido un problema!',
                        confirmButtonText: 'Listo',
                        timer: 5000
                    })
                }
            })
        } else {
            this.setState({ updateV: false });
            MySwal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'A ocurrido un problema!',
                confirmButtonText: 'Listo',
                timer: 5000
            })
        }
    }


    onChangeFecha = (event) => {
        const target = event.target;
        const name = target.name;
        switch (name) {
            case 'fechaInicioDocente':
                let docente = this.state.docentes;
                /*console.log(target.value);*/
                docente.inicio = target.value +'T00:00:00-05:00';
                this.setState({ docentes: docente });
                /*console.log(this.state.docentes);*/
                break;
            case 'fechaFinDocente':
                let docentef = this.state.docentes;
                docentef.fin = target.value + 'T00:00:00-05:00';
                this.setState({ docentes: docentef });
                /*console.log(this.state.docentes);*/
                break;
            case 'fechaInicioSubdecano':
                let sub = this.state.subdecanos;
                /*console.log(target.value);*/
                sub.inicio = target.value + 'T00:00:00-05:00';
                this.setState({ subdecanos: sub });
                //console.log(this.state.subdecanos);
                break;
            case 'fechaFinSubdecano':
                let subf = this.state.subdecanos;
                subf.fin = target.value + 'T00:00:00-05:00';
                this.setState({ subdecanos: subf });
                //console.log(this.state.subdecanos);
                break;
            case 'fechaInicioDecano':
                let dec = this.state.decanos;
                /*console.log(target.value);*/
                dec.inicio = target.value + 'T00:00:00-05:00';
                this.setState({ decanos: dec });
                //console.log(this.state.decanos);
                break;
            case 'fechaFinDecano':
                let decf = this.state.decanos;
                decf.fin = target.value + 'T00:00:00-05:00';
                this.setState({ decanos: decf });
                //console.log(this.state.decanos);
                break;
            case 'fechaInicioVicerrector':
                let vice = this.state.vicerrector;
                /*console.log(target.value);*/
                vice.inicio = target.value + 'T00:00:00-05:00';
                this.setState({ vicerrector: vice });
                //console.log(this.state.vicerrector);
                break;
            case 'fechaFinVicerrector':
                let vicef = this.state.vicerrector;
                vicef.fin = target.value + 'T00:00:00-05:00';
                this.setState({ vicerrector: vicef });
                //console.log(this.state.vicerrector);
                break;
            default:
                //console.log('Algo mal');
                break;
        }
        //console.log(name);
    }

    populate() {
        /*console.log("Populate")*/
        fetch(local + 'Administrador/GetAccesoConfig/', {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                this.setState({
                    loading: false,
                    idperiodo: data.idperiodo,
                    nombrePeriodo: data.nombre,
                    docentes: data.accesoDocentes,
                    subdecanos: data.accesoSubdecanos,
                    decanos: data.accesoDecanos,
                    vicerrector: data.accesoVicerrector
                })
            })
            .catch(function F(error) {
                console.log(error);
            })
    }

    tipoNombre(tipo) {
        let nombre = "";
        switch (tipo) {
            case 'P':
                nombre = "DOCENTE";
                break;
            case 'S':
                nombre = "SUBDECANO/COORDINADOR";
                break;
            case 'D':
                nombre = "DECANO";
                break;
            case 'V':
                nombre = "VICERRECTOR";
                break;
            default:
                nombre = "NOT FOUND";
               break;
        }
        return nombre
    }

    renderConfig() {
        let pInicio = this.state.docentes.inicio;
        return (
            <Card className="my-2">                
                <CardBody>
                    <CardTitle tag="h5">
                        {this.state.nombrePeriodo}
                    </CardTitle>
                    <Table>
                        <thead>
                            <tr>
                                <th>Tipo</th>
                                <th>Fecha Inicio</th>
                                <th>Fecha Fin</th>
                                <th>Actualizar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row">{this.tipoNombre(this.state.docentes.tipoUsuario)}</th>
                                <td>
                                    <Input
                                     id={"fechaInicio" + this.state.idperiodo + this.state.iduser}
                                        name="fechaInicioDocente"
                                        type="date"
                                        onChange={this.onChangeFecha}
                                        value={dateFormat(this.state.docentes.inicio, "isoDate")}
                                        style={{ padding: "0.375rem 0.375rem" }}
                                    />
                                </td>
                                <td>
                                    <Input
                                        id={"fechaFin" + this.state.idperiodo + this.state.iduser}
                                        name="fechaFinDocente"
                                        type="date"
                                        onChange={this.onChangeFecha}
                                        value={dateFormat(this.state.docentes.fin, "isoDate")}
                                        style={{ padding: "0.375rem 0.375rem" }}
                                    />
                                </td>
                                <td><Button color="primary"
                                    disabled={this.state.updateP || this.state.updateS || this.state.updateD || this.state.updateV}
                                    onClick={() => this.handleSaveP()}>
                                    {this.state.updateP ? <Spinner animation="grow" size='sm' /> : 'Actualizar'}
                                </Button></td>
                            </tr>
                            <tr>
                                <th scope="row">{this.tipoNombre(this.state.subdecanos.tipoUsuario)}</th>
                                <td>
                                    <Input
                                        id={"fechaInicio" + this.state.idperiodo + this.state.iduser}
                                        name="fechaInicioSubdecano"
                                        type="date"
                                        onChange={this.onChangeFecha}
                                        value={dateFormat(this.state.subdecanos.inicio, "isoDate")}
                                        style={{ padding: "0.375rem 0.375rem" }}
                                    />
                                </td>
                                <td>
                                    <Input
                                        id={"fechaFin" + this.state.idperiodo + this.state.iduser}
                                        name="fechaFinSubdecano"
                                        type="date"
                                        onChange={this.onChangeFecha}
                                        value={dateFormat(this.state.subdecanos.fin, "isoDate")}
                                        style={{ padding: "0.375rem 0.375rem" }}
                                    />
                                </td>
                                <td><Button color="primary"
                                    disabled={this.state.updateP || this.state.updateS || this.state.updateD || this.state.updateV}
                                    onClick={() => this.handleSaveS()}>
                                    {this.state.updateS ? <Spinner animation="grow" size='sm' /> : 'Actualizar'}
                                </Button></td>
                            </tr>
                            <tr>
                                <th scope="row">{this.tipoNombre(this.state.decanos.tipoUsuario)}</th>
                                <td>
                                    <Input
                                        id={"fechaInicio" + this.state.idperiodo + this.state.iduser}
                                        name="fechaInicioDecano"
                                        type="date"
                                        onChange={this.onChangeFecha}
                                        value={dateFormat(this.state.decanos.inicio, "isoDate")}
                                        style={{ padding: "0.375rem 0.375rem" }}
                                    />
                                </td>
                                <td>
                                    <Input
                                        id={"fechaFin" + this.state.idperiodo + this.state.iduser}
                                        name="fechaFinDecano"
                                        type="date"
                                        onChange={this.onChangeFecha}
                                        value={dateFormat(this.state.decanos.fin, "isoDate")}
                                        style={{ padding: "0.375rem 0.375rem" }}
                                    />
                                </td>
                                <td><Button color="primary"
                                    disabled={this.state.updateP || this.state.updateS || this.state.updateD || this.state.updateV}
                                    onClick={() => this.handleSaveD()}>
                                    {this.state.updateD ? <Spinner animation="grow" size='sm' /> : 'Actualizar'}
                                </Button></td>
                            </tr>
                            <tr>
                                <th scope="row">{this.tipoNombre(this.state.vicerrector.tipoUsuario)}</th>
                                <td>
                                    <Input
                                        id={"fechaInicio" + this.state.idperiodo + this.state.iduser}
                                        name="fechaInicioVicerrector"
                                        type="date"
                                        onChange={this.onChangeFecha}
                                        value={dateFormat(this.state.vicerrector.inicio, "isoDate")}
                                        style={{ padding: "0.375rem 0.375rem" }}
                                    />
                                </td>
                                <td>
                                    <Input
                                        id={"fechaFin" + this.state.idperiodo + this.state.iduser}
                                        name="fechaFinVicerrector"
                                        type="date"
                                        onChange={this.onChangeFecha}
                                        value={dateFormat(this.state.vicerrector.fin, "isoDate")}
                                        style={{ padding: "0.375rem 0.375rem" }}
                                    />
                                </td>
                                <td><Button color="primary"
                                    disabled={this.state.updateP || this.state.updateS || this.state.updateD || this.state.updateV}
                                    onClick={() => this.handleSaveV()}>
                                    {this.state.updateV ? <Spinner animation="grow" size='sm' /> : 'Actualizar'}
                                </Button></td>
                            </tr>
                        </tbody>
                    </Table>
                    {/*<Form>*/}
                    {/*    <Row>*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label for="exampleSelect">{this.tipoNombre(this.state.docentes.tipoUsuario)}</Label>*/}
                    {/*            <Input name="tipoUsuario" hidden value={this.state.docentes.tipoUsuario} />*/}
                    {/*        </FormGroup>*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label for="exampleSelect">Fecha Inicio</Label>*/}
                    {/*            <Input*/}
                    {/*                id={"fechaInicio" + this.state.idperiodo + this.state.iduser}*/}
                    {/*                name="fechaInicio"*/}
                    {/*                type="date"*/}
                    {/*                defaultValue={dateFormat(this.state.docentes.inicio, "isoDate")}*/}
                    {/*                style={{ padding: "0.375rem 0.375rem" }}*/}
                    {/*            />*/}
                    {/*        </FormGroup>*/}
                    {/*        <FormGroup>*/}
                    {/*            <Label for="exampleSelect">Fecha Fin</Label>*/}
                    {/*            <Input*/}
                    {/*                id={"fechaFin" + this.state.idperiodo + this.state.iduser}*/}
                    {/*                name="fechaFin"*/}
                    {/*                type="date"*/}
                    {/*                defaultValue={dateFormat(this.state.docentes.fin, "isoDate")}*/}
                    {/*                style={{ padding: "0.375rem 0.375rem" }}*/}
                    {/*            />*/}
                    {/*        </FormGroup>*/}
                    {/*        <FormGroup>*/}
                    {/*            <Button type="submit" >Actualizar</Button>*/}
                    {/*        </FormGroup>*/}
                    {/*    </Row> */}
                    {/*</Form>*/}
                </CardBody>
              </Card>
            );
    }

    render() {
        const currentUser = this.context;

        if (currentUser == null) {
            return <><Spinner animation="grow" /></>;
        }

        let content = this.state.loading ? <><Spinner animation="grow" /></>
            : this.renderConfig();

        return (
            <div>
                {content}
            </div>
        );
    }
}
Configuracion.contextType = AppContext;
export default Configuracion;